import { useTranslation } from 'react-i18next';
import { Divider, Paragraph } from 'component-library';
import { type PartnerResItem, type AddContainerOrderDetails } from '@sr/types';
import { colors } from '../../../../component_library/src/themes';
import { PartnerInfo } from '../PartnerInfo';
import { KeyValuePair } from './KeyValuePair';
import { DetailsWrapper, KeyValuePairWrapper, Row } from './styles';

type OrderDetailsProps = {
  orderDetails: AddContainerOrderDetails;
  locationDisplay?: PartnerResItem;
  colCount?: number;
  hideAdditionalRecipient?: boolean;
};

export const OrderDetails = ({
  orderDetails,
  locationDisplay,
  colCount = 3,
  hideAdditionalRecipient = false,
}: OrderDetailsProps) => {
  const { t } = useTranslation();

  const largeGap = colCount === 3;

  return (
    <>
      <Row>
        <DetailsWrapper colCount={colCount} largeGap={largeGap}>
          {locationDisplay && (
            <KeyValuePair
              label={t('add.container.step3.parent.label')}
              value={
                <PartnerInfo
                  partner={locationDisplay}
                  includeLocationCount={false}
                  normalDescription={true}
                />
              }
            />
          )}
          {!!orderDetails.contactInformation && (
            <KeyValuePair
              label={t('add.container.step3.contact-details.contact.label')}
              value={
                <>
                  {orderDetails.contactInformation.name}
                  <br />
                  {orderDetails.contactInformation.phone}
                  {orderDetails.contactInformation.email && (
                    <>
                      <br />
                      {orderDetails.contactInformation.email}
                    </>
                  )}
                </>
              }
            />
          )}
          <KeyValuePair
            label={t('add.container.step3.contact-details.comment.label')}
            value={orderDetails.comment ?? '-'}
          />
          <KeyValuePairWrapper>
            <Paragraph color={colors.primary.grey} mb="none">
              {t('add.container.step3.contact-details.file-upload.label')}
            </Paragraph>
            {orderDetails.fileAttachments?.length ? (
              orderDetails.fileAttachments.map((file) => (
                <Paragraph key={file.id}>{file.fileName}</Paragraph>
              ))
            ) : (
              <Paragraph>-</Paragraph>
            )}
          </KeyValuePairWrapper>
        </DetailsWrapper>
      </Row>
      {orderDetails.additionalRecipient && !hideAdditionalRecipient && (
        <>
          <Divider />
          <Row>
            <KeyValuePair
              label={t('request.new.project.confirmation.additional-recipient.label')}
              value={orderDetails.additionalRecipient}
            />
          </Row>
        </>
      )}
    </>
  );
};
